import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'

import Styles from './index.scss'

const renderButton = props => (
  <div className={Styles['btn-container']}>
    {props.isCancelExist && (
      <button
        className={Styles['btn-cancel']}
        onClick={props.onCancel}
      >
        Cancel
      </button>
    )}
    <button
      className={`${Styles['btn-confirm']}`}
      onClick={props.onSubmit}
    >
      Confirm
    </button>
  </div>
)

const DialogAlert = props => (
  <Dialog
    title="Warning"
    actions={renderButton(props)}
    modal={false}
    open={props.isOpen}
    onRequestClose={props.onClose}
  >
    {props.bodyMessage}
  </Dialog>
)

renderButton.defaultProps = {
  onCancel: () => { },
  onSubmit: () => { },
  isCancelExist: true,
}

renderButton.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isCancelExist: PropTypes.bool,
}

DialogAlert.defaultProps = {
  isOpen: false,
  onClose: () => { },
  onCancel: () => { },
  onSubmit: () => { },
  bodyMessage: '',
  isCancelExist: true,
}

DialogAlert.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  bodyMessage: PropTypes.string,
}

export default DialogAlert
